module.exports = __webpack_public_path__ + "static/media/apis-export.70ed9158.png";